import React from 'react';
import { Modal, Descriptions } from 'antd';

const BillDetailsModal = ({ visible, onClose, data, type }) => {
  if (!data) return null;

  const renderCourierBillDetails = () => (
    <Descriptions bordered column={2}>
      <Descriptions.Item label="运单号码">{data.waybillNumber}</Descriptions.Item>
      <Descriptions.Item label="日期">{data.date}</Descriptions.Item>
      <Descriptions.Item label="公司名称">{data.companyName}</Descriptions.Item>
      <Descriptions.Item label="产品类型">{data.productType}</Descriptions.Item>
      <Descriptions.Item label="付款方式">{data.paymentMethod}</Descriptions.Item>
      <Descriptions.Item label="增值费用">{data.valueAddedFee}</Descriptions.Item>
      <Descriptions.Item label="目的地(省名)">{data.destinationProvince}</Descriptions.Item>
      <Descriptions.Item label="计费重量">{data.billingWeight} kg</Descriptions.Item>
      <Descriptions.Item label="快递费">¥{data.expressFee.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="转向客服费">¥{data.customerServiceFee.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="应付金额">¥{data.payableAmount.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="状态">{data.status}</Descriptions.Item>
      <Descriptions.Item label="快递公司">{data.courier?.name}</Descriptions.Item>
    </Descriptions>
  );

  const renderCustomsBillDetails = () => (
    <Descriptions bordered column={2}>
      <Descriptions.Item label="主单号">{data.masterNumber}</Descriptions.Item>
      <Descriptions.Item label="国别">{data.country}</Descriptions.Item>
      <Descriptions.Item label="到港日期">{data.arrivalDate}</Descriptions.Item>
      <Descriptions.Item label="入库日期">{data.storageInDate}</Descriptions.Item>
      <Descriptions.Item label="出库日期">{data.storageOutDate}</Descriptions.Item>
      <Descriptions.Item label="件数">{data.packageCount}</Descriptions.Item>
      <Descriptions.Item label="分单数">{data.houseBillCount}</Descriptions.Item>
      <Descriptions.Item label="毛重">{data.grossWeight} kg</Descriptions.Item>
      <Descriptions.Item label="计费重量">{data.billingWeight} kg</Descriptions.Item>
      <Descriptions.Item label="身份证验证费">¥{data.idVerificationFee.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="清关费">¥{data.customsClearanceFee.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="库区收费差价">¥{data.storageFeeDifference.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="库区费用">¥{data.storageFee.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="预付税金">¥{data.prepaidTax.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="税金差额">¥{data.taxDifference.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="合计金额">¥{data.totalAmount.toFixed(2)}</Descriptions.Item>
      <Descriptions.Item label="验证数">{data.verificationCount}</Descriptions.Item>
    </Descriptions>
  );

  return (
    <Modal
      title={type === 'courier' ? '快递账单详情' : '清关账单详情'}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {type === 'courier' ? renderCourierBillDetails() : renderCustomsBillDetails()}
    </Modal>
  );
};

export default BillDetailsModal;
